import AvgPriceSqMeterChart from "components/Charts/AvgPriceSqMeterChart";
import AverageSquareMeterChart from "components/Charts/AverageSquareMeterChart";
import DashboardMap from "components/Map/DashboardMap";
import React from "react";
import AverageROIChart from "./AverageROIChart";
import PropertyDistributionChart from "./PropertyDistributionChart";

const HousePriceCalculator = () => {
  return (
    <div className="flex h-full items-start flex-col  xl:flex-row space-y-4 xl:space-y-0 xl:space-x-[15px]">
      <DashboardMap />
      <div className="w-full xl:w-[31.9%] space-y-4  xl:space-y-[18px]">
        <AverageSquareMeterChart />
        <AverageROIChart />
      </div>
      <div className="w-full xl:w-[31.9%] space-y-4 xl:space-y-[18px]">
        <AvgPriceSqMeterChart />
        <PropertyDistributionChart />
      </div>
    </div>
  );
};

export default HousePriceCalculator;
